import { render, staticRenderFns } from "./boxLabelManage.vue?vue&type=template&id=571d0223&scoped=true"
import script from "./boxLabelManage.vue?vue&type=script&lang=js"
export * from "./boxLabelManage.vue?vue&type=script&lang=js"
import style0 from "./boxLabelManage.vue?vue&type=style&index=0&id=571d0223&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571d0223",
  null
  
)

export default component.exports